let $ = require('jquery');

function searchToggle() {
  $('.search-btn').on('click', function () {
    $('.region-header > .search-block-form').fadeToggle(200);
  });
}

export default searchToggle;
